import { useRef, useEffect } from "react";
import { Flex, Paper, Header3, MainText, PrimaryButton, SecondaryButton } from "@base-ui";
import { closePopup, blockDefaultEvent } from "utils/events";
import { useLockedFocusArea } from "hooks";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function ConfirmPopup(props) {
  var title = props.title,
    ingress = props.ingress,
    callback = props.callback,
    confirmLabel = props.confirmLabel,
    hideCancel = props.hideCancel,
    subtext = props.subtext,
    variant = props.variant;
  var containerRef = useRef();
  var firstRef = useRef();
  var lastRef = useRef();
  useLockedFocusArea(containerRef, firstRef, lastRef);
  useEffect(function () {
    var _document$getElementB;
    (_document$getElementB = document.getElementById("unitlist-name")) === null || _document$getElementB === void 0 ? void 0 : _document$getElementB.focus();
  }, []);
  var handleCancel = function handleCancel(e) {
    blockDefaultEvent(e);
    closePopup();
  };
  var handleConfirm = function handleConfirm() {
    closePopup();
    callback();
  };
  var noIngress = !ingress ? "0px" : "40px";
  return /*#__PURE__*/_jsxs(Paper.Column, {
    width: "500px",
    ref: containerRef,
    children: [/*#__PURE__*/_jsx(Header3, {
      id: "dialog-title",
      inverted: true,
      p: "15px 20px",
      backgroundColor: "P3",
      m: "0",
      children: title
    }), /*#__PURE__*/_jsxs(Flex.Column, {
      p: "sm",
      children: [/*#__PURE__*/_jsx(MainText, {
        mb: noIngress ? "0" : "40px",
        children: ingress
      }), subtext && /*#__PURE__*/_jsx(MainText, {
        mb: "25px",
        fontStyle: "italic",
        children: subtext
      }), /*#__PURE__*/_jsxs(Flex.Row, {
        justifyContent: "flex-end",
        mt: "20px",
        children: [!hideCancel && /*#__PURE__*/_jsx(SecondaryButton, {
          ref: firstRef,
          id: "leave-popup",
          mr: "10px",
          width: "120px",
          onClick: handleCancel,
          children: "Avbryt"
        }), /*#__PURE__*/_jsx(PrimaryButton, {
          id: "confirm",
          ref: lastRef,
          width: "auto",
          p: "0 40px",
          onClick: handleConfirm,
          variant: variant,
          children: confirmLabel
        })]
      })]
    })]
  });
}